module.exports = __webpack_public_path__ + "static/media/colore_testo.101e6c98.png";